/* eslint-disable import/prefer-default-export */
export const splitGamesIntoUnits = (games = [], itemsPerUnit, allowIncompleteUnits) => {
	const units = [];
	const unitsAmount = Math[allowIncompleteUnits ? 'ceil' : 'floor'](games.length / itemsPerUnit);

	for (let i = 0; i < unitsAmount; i += 1) {
		const currentIndex = i * itemsPerUnit;
		units[i] = games.slice(currentIndex, currentIndex + itemsPerUnit);
	}
	return units;
};
